module.exports = __webpack_public_path__ + "static/media/vplus_background_header.ab7a0ab0.png";